		<template>
			<v-container fluid class="monitorSite px-2 fade-in">
				<v-layout v-if="loading===true" wrap row>
					<v-flex xs12>
						<div class="spin-container">
								<div class="q-spinner"></div>
								<p>{{loadingStatusMessage}}</p>
						</div>
					</v-flex>
				</v-layout>
				<v-app class="survey-container">
					<v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
					<v-avatar slot="icon" color="deep-orange accent-4" size="40">
						<v-icon color="white">
							people_alt
						</v-icon>
					</v-avatar>
					You are viewing the survey.
					<template v-slot:actions>
						<v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
					</template>
					</v-banner>
				<br/>
				<div>
					<v-btn normal class="form-button" @click="onHome">
						<v-icon medium>home</v-icon>&nbsp; Home
					</v-btn>
					<v-btn normal class="form-button" @click="onCancel">
						<v-icon medium></v-icon>&nbsp; Cancel
					</v-btn>
				</div>
				<v-layout class="page-body bg-light-blue" style="margin-top:10px;">
					<v-layout row>
						<v-flex column md12>
							<v-data-table :headers="headers" :items="rowData"	 item-key="id" :search="search"	 :custom-filter="globalFilter" class="elevation-1">
						<template v-slot:top>
							<v-toolbar flat>
								<v-toolbar-title class="report-title">Monitor Suboffice Progress</v-toolbar-title>
							</v-toolbar>
							<v-text-field id="reportSearch" v-model="search" label="Search" class="mx-4 search-input"></v-text-field>
						</template>
							<template v-slot:item.1="{ item }">
								<v-icon v-if="item['1'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['1'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.2="{ item }">
								<v-icon v-if="item['2'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['2'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.3="{ item }">
								<v-icon v-if="item['3'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['3'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.4="{ item }">
								<v-icon v-if="item['4'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['4'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.5="{ item }">
								<v-icon v-if="item['5'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['5'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.6="{ item }">
								<v-icon v-if="item['6'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['6'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.7="{ item }">
								<v-icon v-if="item['7'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['7'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.8="{ item }">
								<v-icon v-if="item['8'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['8'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.9="{ item }">
								<v-icon v-if="item['9'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['9'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.10="{ item }">
								<v-icon v-if="item['10'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['10'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.11="{ item }">
								<v-icon v-if="item['11'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['11'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.12="{ item }">
								<v-icon v-if="item['12'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['12'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.13="{ item }">
								<v-icon v-if="item['13'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['13'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.14="{ item }">
								<v-icon v-if="item['14'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['14'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.15="{ item }">
								<v-icon v-if="item['15'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['15'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.16="{ item }">
								<v-icon v-if="item['16'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['16'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.17="{ item }">
								<v-icon v-if="item['17'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['17'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.18="{ item }">
								<v-icon v-if="item['18'] === 'NotStarted'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['18'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.19="{ item }">
								<v-icon v-if="item['19'] === 'NotStarted' || item['19'] === 'NA'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['19'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.20="{ item }">
								<v-icon v-if="item['20'] === 'NotStarted' || item['20'] === 'NA'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-icon v-if="item['20'] === 'NA'" class="status-icon"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['20'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
							<template v-slot:item.21="{ item }">
								<v-icon v-if="item['21'] === 'NotStarted' || item['21'] === 'NA'" class="status-icon" @click="onImpersonate(item.surveyId)"></v-icon>
								<v-icon v-if="item['21'] === 'NA'" class="status-icon"></v-icon>
								<v-img v-else class="status-img" aria-hidden="true" max-height="60" contain :src="getQuestionStatusIcon(item['21'])"  @click="onImpersonate(item.surveyId)"></v-img>
							</template>
						</v-data-table>
					</v-flex>
				</v-layout>
			</v-layout>
		<Footer></Footer>
		</v-app>
	</v-container>
</template>
<script>

import { adminDataCollectionService } from "@/services/adminDataCollectionService.js";
import router from "@/router";
import { authTokenService } from "@/services/authTokenService.js";

export default {
name: "ProgressMonitorSub",
data: () => ({
 active: false,
 expanded: [],
 singleExpand: false,
 headers: [
	{ text: "User ID", value: "userId" },
	{ text: "Office Name", value: "officeName" },
	{ text: "Abbreviation", value: "officeAbbreviation" },
	{ text: "Q1", value: "1" },
	{ text: "Q2", value: "2" },
	{ text: "Q3", value: "3" },
	{ text: "Q4", value: "4" },
	{ text: "Q5", value: "5" },
	{ text: "Q6", value: "6" },
	{ text: "Q7", value: "7" },
	{ text: "Q8", value: "8" },
	{ text: "Q9", value: "9" },
	{ text: "Q10", value: "10" },
	{ text: "Q11", value: "11" },
	{ text: "Q12", value: "12" },
	{ text: "Q13", value: "13" },
	{ text: "Q14", value: "14" },
	{ text: "Q15", value: "15" },
	{ text: "Q16", value: "16" },
	{ text: "Q17", value: "17" },
	{ text: "Q18", value: "18" },
	{ text: "Q19", value: "19" },
	{ text: "Q20", value: "20" },
	{ text: "Q21", value: "21" },
	{ text: "Survey Status", value: "surveyStatus" }
 ],
 tmp: {},
 columnDefs: null,
 rowData: [],
 chartData: [],
 officeEntityTypes: [],
 search: null,
 clickedRow: null,
 loading: false,
 impersonation: false,
 loadingStatusMessage: 'Loading suboffice survey status.',
 idx: 0
}),
methods: {
 onImpersonate: function (surveyId) {
	if (surveyId != null) {
		authTokenService.setActiveSurveyId(surveyId);
		router.push({ name: "home", params: { previousComponentName: this.$route.name } });
	} else {
		console.log("Impersonation error: null survey ID");
	}
 },
 myMessageUpdate: function () {
	if (this.idx < 4) {
		this.loadingStatusMessage = this.wittyMessages[this.idx++];
	}
 },
 convertData () {
	if (!this.rowData || this.rowData.length === 0) return;
	this.rowData.forEach(element => {
		let qStatuses = element.questionStatuses;
		qStatuses.forEach(qStatus => {
			element[qStatus.questionDisplayId] = qStatus.questionStatus;
		});
		if (qStatuses.length === 18) {
			element['19'] = 'NA';
			element['20'] = 'NA';
		}
	});
 },
 expand (value) {
	this.expanded.push(value);
 },
 globalFilter (value, search, item) {
	return (
		value != null &&
		search != null &&
		value
			.toString()
			.toLocaleLowerCase()
			.indexOf(search.toLocaleLowerCase()) !== -1
	);
 },
 getQuestionStatusIcon (status) {
	if (status) {
		switch (status) {
			case 'NotLoggedIn':
				return require('@/assets/partial-32.png');
			case 'NotStarted':
				return require('@/assets/notStarted.png');
			case 'Complete':
					return require('@/assets/check-64.png');
			case 'InProgress':
					return require('@/assets/partial-16.png');
			case 'Errors':
					return require('@/assets/error-64.png');
			case 'Warnings':
				return require('@/assets/warning-64.png');
		}
	}
 },
	exit () { router.push({ name: 'admin.stats' }); },
	onHome () { router.push({ name: 'landing' }); },
	onCancel () { router.push({ name: 'reportingunits' }); }
},
mounted () {
 let me = this;
 me.loading = true;
 const activeSurveyId = authTokenService.getActiveSurveyId();
 me.rowData = [];
 adminDataCollectionService.getSubOfficeProgressReport(activeSurveyId, me.search).then(function (resp) {
		me.rowData = resp.data;
		me.convertData();
		me.loading = false;
	})
	.catch(function (err) {
			console.log(err);
			console.log("Error loading survey status in survey page");
			me.loading = false;
			throw err;
	});
}
};
</script>

<style scoped>
.status-img {
 width: 16px;
 height: 16px;
}
.status-img:hover,
.status-icon:hover {
 cursor: pointer;
}
.sub-table {
 background-color: lightgray !important;
}
.spin-container {
 position: absolute;
 top: 5px;
 bottom: -5px;
 left: 0;
 right: 0;
 background-color: #d9e2f3;
 z-index: 10;
}
.spin-container > p {
 text-align: center;
 font-weight: bold;
 margin: 0;
 font-size: 32px;
}
.q-spinner {
height: 250px;
width: 250px;
border: 3px solid transparent;
border-radius: 50%;
border-top: 4px solid #4d5b9b;
-webkit-animation: spin 4s linear infinite;
animation: spin 4s linear infinite;
position: relative;
margin: 50px auto;
}
.q-spinner::before,
.q-spinner::after {
content: "";
position: absolute;
top: 6px;
bottom: 6px;
left: 6px;
right: 6px;
border-radius: 50%;
border: 4px solid transparent;
}
.q-spinner::before {
border-top-color: #17a2b8;
-webkit-animation: 3s spin linear infinite;
animation: 3s spin linear infinite;
}
.q-spinner::after {
border-top-color: #1976d2;
-webkit-animation: spin 1.5s linear infinite;
animation: spin 1.5s linear infinite;
}
@-webkit-keyframes spin {
	from {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

@keyframes spin {
	from {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
	}
	to {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
	}
}

.report-title {
	font-family: Georgia, Times, Times New Roman, san-serif;
	font-size: 16pt;
	color: #14427d;
	font-weight: bold;
}

.search-input input {
	text-align: left !important;
	width: 200px;
}
#reportSearch {
	text-align: left;
}

#reportSearch input {
	text-align: left;
}

#reportSearch .v-text-field__slot > input {
 text-align: left;
}

.v-text-field__slot > input {
 text-align: left !important;
}

</style>
